import React from 'react'
import styled from 'styled-components'
import Button from '@material-ui/core/Button'
import {useAttendeeVariables} from 'Event'
import EditModeOnly from 'Event/Dashboard/editor/views/EditModeOnly'
import {useToggle} from 'lib/toggle'
import {Ordered} from 'lib/list'
import {RemoveButton} from 'organization/Event/DashboardConfig/ConfigDialog'
import Content from 'lib/ui/form/TextEditor/Content'
import {useLeftyTemplate} from 'Event/template/Lefty'
import {
  HasOffset,
  useEditSidebarItem,
} from 'Event/template/Lefty/Dashboard/Sidebar/SidebarItem'
import {TextConfig} from 'Event/template/Lefty/Dashboard/Sidebar/SidebarItem/Text/TextConfig'
import Section, {
  SectionBox,
} from 'Event/template/Lefty/Dashboard/Sidebar/Section'
import {useEditMode} from 'Event/EditModeProvider'
import {HasSchedule} from 'lib/ui/layout/Scheduled'
import {HasRules} from 'Event/attendee-rules'

export const TEXT = 'Text'

export interface TextProps extends Ordered, HasSchedule, HasOffset, HasRules {
  type: typeof TEXT
  padding: number
  body: string
  isEnabled: boolean
}

export const createText = (): TextProps => ({
  type: TEXT,
  padding: 5,
  body: 'This is sample text.  Click Edit Text to modify this text.',
  isEnabled: true,
  offsetTop: 0,
  offsetBottom: 0,
})

export default function Text(props: TextProps & {id: string}) {
  const {sidebar} = useLeftyTemplate()
  const {body, padding, isEnabled, offsetTop, offsetBottom} = props
  const v = useAttendeeVariables()
  const {flag: configVisible, toggle: toggleConfig} = useToggle()
  const isEditMode = useEditMode()

  if (!isEditMode && !isEnabled) {
    return null
  }

  return (
    // Disable side padding to allow text to go all all the
    // way to border.
    <Section offsetTop={offsetTop} offsetBottom={offsetBottom}>
      <Body aria-label="text" color={sidebar.textColor} padding={padding}>
        {v(body)}
      </Body>
      <EditModeOnly>
        <TextConfig
          showing={configVisible}
          onClose={toggleConfig}
          text={props}
          id={props.id}
        />
        <SectionBox disablePaddingY>
          <EditButton
            onClick={toggleConfig}
            variant="contained"
            color="primary"
            fullWidth
            size="large"
            aria-label="edit text"
          >
            Edit Text
          </EditButton>
          <RemoveTextButton />
        </SectionBox>
      </EditModeOnly>
    </Section>
  )
}

function RemoveTextButton() {
  const {removeList, id: listId} = useEditSidebarItem()
  const remove = () => {
    const localizations = [`sidebar_text_list_${listId}_body`]

    removeList(localizations)
  }
  return (
    <RemoveButton size="large" showing onClick={remove}>
      Remove Text
    </RemoveButton>
  )
}

const Body = styled(Content)<{
  color: string | null
  padding: number
}>`
  color: ${(props) => props.color};
  padding: ${(props) => props.padding}px;
`

const EditButton = styled(Button)`
  margin-bottom: ${(props) => props.theme.spacing[2]}!important;
`
